<template>
  <section class="grid-section" id="identidade-verbal-tom-comunicacao-e-marketing" data-search-anchor>
    <h1 class="grid-tone-title">{{ carouselGridTitle }}</h1>
    <CarouselSection :cards="cards">
      <template #card-content="{ card }">
        <CardContent :lines="card.lines" :icons="card.icons" />
      </template>
      
      <template #nav-center>
        <div class="carousel-legend-container">
          <div class="carousel-legend-paragraph-wrapper">
            <div class="carousel-legend-paragraph">
              <p>+ Institucional e estruturado</p>
              <p>+ Comercial e dinâmico</p>
            </div>
            <div class="carousel-legend-circles-wrapper">
              <div class="carousel-legend-line">
                <LineGradientWhite />
              </div>
              <div class="carousel-circles">
                <ThreeCirclesWhite /><TwoCircleWhite /><OneCircleWhite /><BlankCirclesWhite />
              </div>
            </div>
          </div>
        </div>
      </template>
    </CarouselSection>
  </section>
</template>

<script lang="ts">
import CarouselSection from './CarouselSection.vue'
import CardContent from './CardContent.vue'
import LineGradientWhite from '@/assets/icons/LineGradientWhite.vue'
import BlankCirclesWhite from '@/assets/icons/BlankCirclesWhite.vue'
import OneCircleWhite from '@/assets/icons/OneCircleWhite.vue'
import TwoCircleWhite from '@/assets/icons/TwoCircleWhite.vue'
import ThreeCirclesWhite from '@/assets/icons/ThreeCirclesWhite.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TonePageMixin from '@/mixins/tone-page-mixin'
import { TonePageStore } from '@/store/verbal-identity-page/tone-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: {
    CarouselSection,
    CardContent,
    LineGradientWhite,
    BlankCirclesWhite,
    OneCircleWhite,
    TwoCircleWhite,
    ThreeCirclesWhite
  }
})
export default class ToneGridSection extends Mixins(TonePageMixin) {
  tonePageStore: PageStoreContract = getModule(TonePageStore, this.$store)
  
  get carouselGridTitle(): string {
    return this.getElementText(6, 0)
  }

  async getTonePage(): Promise<void> {
    await this.tonePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.tonePageStore.isLoading) {
      await this.getTonePage()
    }
  }

  containerIndexes = [2, 3, 4, 5]

  get cards() {
    const iconSets = [
      [ThreeCirclesWhite, ThreeCirclesWhite, ThreeCirclesWhite, OneCircleWhite],
      [TwoCircleWhite, ThreeCirclesWhite, TwoCircleWhite, ThreeCirclesWhite],
      [OneCircleWhite, OneCircleWhite, TwoCircleWhite, ThreeCirclesWhite],
      [BlankCirclesWhite, BlankCirclesWhite, BlankCirclesWhite, ThreeCirclesWhite]
    ]

    return this.containerIndexes.map((containerIndex, index) => {
      const container = this.getContainer(containerIndex)
      if (!container || !container.elements) return { title: '', lines: [], icons: [] }

      const title = container.elements[0]?.title || ''
      
      const paragraphs = container.elements.slice(0, 2).map(el => ({ text: el.text || '' }))

      return { title, lines: paragraphs, icons: iconSets[index] }
    })
  }
}
</script>

<style scoped>
.grid-section {  
  margin-top: 60px;
  width: 1032px;
}

.carousel-container{
  display: flex;
  justify-content: center;
}

.grid-tone-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-top: 0;
  white-space: pre;
}

.carousel-legend-paragraph {
  display: flex;
  gap: 96px;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: white;
}

.carousel-legend-container {
  width: 540px;
  height: 109px;
  border-radius: 20px;
  background: linear-gradient(
    90deg,
    #0079fd -37.91%,
    #2d51fb 20.11%,
    #5a29fa 78.13%,
    #8800f8 137.91%
  );
}

.carousel-legend-paragraph-wrapper {
  display: grid;
  justify-content: center; 
}

.carousel-legend-circles-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.carousel-circles {
  display: flex;
  gap: 65px;
}

::v-deep .carousel-nav {
  gap: 195px;
}

</style>
